import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const getIconStyle = (size, style) => (size ? { ...style, fontSize: size, width: size, height: size } : style);

const AppMenuMyChargePointsIcon = ({ primaryColor = '#414042', secondaryColor = '#ffffff', strokeColor = '#414042', size, style, ...props }) => (
    <SvgIcon viewBox='0 0 16.61 16.61' style={getIconStyle(size, style)} {...props}>
        <path
            fill={primaryColor}
            d='M10.96,4.41c-.12,0-.18.06-.18.16l-.68-.33v2.92c0,.32-.17.49-.54.49l-.6,1.15-.77,1.08h.9l-2,2.34.6-1.75h-.51l.54-1.66h1.24s.6-1.16.6-1.16h-2.94c-.35,0-.52-.17-.52-.49v-2.92c0-.33.17-.49.52-.49h2.94c.37,0,.54.16.54.49l.68.33v1.27c.01.09.07.14.18.14h.45v4.55h-.82V3.68c0-.17-.04-.3-.13-.37-.09-.08-.22-.11-.39-.11h-3.96c-.16,0-.29.03-.38.11-.1.08-.15.2-.15.37v8.6h-.9c-.37,0-.54.17-.54.49v.64h7.89v-.64c0-.32-.18-.49-.54-.49h-.91v-1.36h.9s.06,0,.1-.02c0,.01.01.01.02.01.06,0,.11-.01.16-.06.04-.05.06-.09.06-.15v-4.73h.45c.11,0,.17-.06.17-.17v-1.24c0-.1-.06-.16-.17-.16h-1.33Z'
        />
        <polyline fill={secondaryColor} points='8.93 8.82 8.16 9.9 9.06 9.9 7.07 12.24 7.66 10.49 7.15 10.49 7.69 8.83 8.93 8.82' />
        <path fill='none' stroke={strokeColor} strokeWidth='0.5' d='M8.3,16.36c4.45,0,8.05-3.61,8.05-8.05S12.75.25,8.3.25.25,3.86.25,8.3s3.61,8.05,8.05,8.05h0Z' />
    </SvgIcon>
);

export default AppMenuMyChargePointsIcon;